import { render, staticRenderFns } from "./ListDisputeView.vue?vue&type=template&id=837288b8&"
import script from "./ListDisputeView.vue?vue&type=script&lang=js&"
export * from "./ListDisputeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports